import { usePageView } from '@fs/zion-analytics'
import React, { useRef } from 'react'
import { ContentAdd } from '@fs/zion-icon/dist/cjs/icons'
import { Divider, H3, Row, Select, Separator, useOverlay, IconButton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../../app/PageTitleContext'
import RegisterKioskOverlay from './RegisterKioskOverlay'
import TempleKioskPicker from './TempleKioskPicker'
import useKioskDropdownOptions from './hooks/useKioskDropdownOptions'
import KioskDetails from './KioskDetails'
import { getKioskById } from '../../../services/templeKioskService'
import useTempleKiosks from './hooks/useTempleKiosks'

export default function TempleKiosks() {
  usePageView({ page_detail: 'DMConsole:TempleKiosks' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.temple.kiosks'))
  const { kiosksState, kiosksActions } = useTempleKiosks()
  const addKioskOverlay = useOverlay()
  const { dropdownOptions } = useKioskDropdownOptions({ languages: kiosksState.languages })
  const editableFieldsRef = useRef({})

  const handleRegisterKioskSuccess = (kioskId) => {
    getKioskById(kioskId).then((response) => {
      kiosksActions.setKiosks((prev) => [...prev, response.data])
      kiosksActions.setKioskSuggestions((prev) => [
        ...prev,
        {
          primaryText: `${response.data.templeCode} - ${response.data.locationDescription}`,
          secondaryText: kioskId,
          authorized: response.data.authorized,
        },
      ])
      kiosksActions.setSelectedKiosk(response.data)
      kiosksActions.setKioskInputText(`${response.data.templeCode} - ${response.data.locationDescription}`)
    })
  }

  return (
    <>
      <H3>{t('temple.subnav.kiosks', 'Kiosks')}</H3>
      <Row>
        <Select
          id="kioskListSelect"
          hidePlaceholder
          value={kiosksState.filterByAuthorized.toString()}
          label={t('temple.kiosks.filter', 'Filter')}
          options={dropdownOptions('authorizedFilter')}
          onChange={(e) => {
            kiosksActions.setFilterByAuthorized(e.target.value)
            kiosksActions.setKioskInputText('')
            kiosksActions.setSelectedKiosk(null)
          }}
        />
      </Row>
      <Row>
        <TempleKioskPicker kiosksState={kiosksState} kiosksActions={kiosksActions} growX />
        <IconButton
          id="addKioskButton"
          aria-label="Register Kiosk"
          Icon={ContentAdd}
          onClick={addKioskOverlay.handleClick}
          color="green"
          emphasis="high"
        />
        <RegisterKioskOverlay
          {...addKioskOverlay}
          dropdownOptions={dropdownOptions}
          onSuccess={handleRegisterKioskSuccess}
        />
      </Row>
      <Divider />
      <Separator />
      <KioskDetails kiosksState={kiosksState} kiosksActions={kiosksActions} editableFieldsRef={editableFieldsRef} />
    </>
  )
}
